import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Switch, Route } from 'react-router-dom'

import Page404 from 'Containers/404'
import Header from 'Components/Header'
import Footer from 'Components/Footer'
import { WhiteLayout, PaddedContent } from 'Common/styled'
import HomePage from 'Components/pages/HomePage/HomePage'

class App extends Component {
  static propTypes = {
    user: PropTypes.object,
  }

  render() {
    return (
      <WhiteLayout>
        <Header
          hasTour={false}
        />
        <PaddedContent>
          <Switch>
            <Route component={HomePage} exact path={'/'} />
            <Route component={Page404} />
          </Switch>
        </PaddedContent>
        <Footer />
      </WhiteLayout>
    )
  }
}

const mapStateToProps = state => ({
  authData: state.auth,
})

export default connect(mapStateToProps)(App)
